// extracted by css-extract-rspack-plugin
export default {"cls1":"CtaIconLock-cls1_YEc","cls2":"CtaIconLock-cls2_7qA CtaIconLock-cls1_YEc"};